// Error handling and logging
import '@/js/bootstrap/handleError';

// Laravel
import '@/js/bootstrap/laravel';
import '@/js/bootstrap/channels';

// Frameworks
import '@/js/bootstrap/alpinejs';
import '@/js/bootstrap/vuejs';

// Librairies
import '@/js/bootstrap/chart';
// import '@/js/bootstrap/anime';

// Runtime
import '@/js/bootstrap/runtime';

window.dispatch('app:loaded');
